/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'utils/moment';
import { INSPECTIONS } from '../../../constants/RouterConstants';
import {
  fetchInspectionAnswer,
  clearInspectionAnswer,
  getChecklistAttachments,
  fetchShiftTypes
} from '../redux/actions';
import SectionHeader from '../../../components/sectionHeader';
import DataSummary from './components/DataSummary';
import AdditionalInformation from './components/AdditionalInformation';
import Selector from './components/Selector';
import FieldDetail from './components/FieldDetail';
import { importAllImages } from '../../../utils/helpers';
import Loading from '../../../components/loading';
import styles from '../inspections.module.scss';
import HeaderBack from '../../../components/headerBack';
import { checkChecklistCondition } from '../InspectionUtils';

class SubmissionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeInspectionField: undefined,
      view: 'list',
      inspectionDropdown: false,
      delPopup: false,
      loadingStatus: true,
      isPressed: false,
      init: true,
      additionalFields: {},
      inspFields: {},
      shiftSetting: undefined,
      inspectionReview: undefined,
      initialRender: true,
      emailModal: false
    };

    this.changeSelectedField = this.changeSelectedField.bind(this);
    this.images = importAllImages(
      require.context(
        '../../../icons/inspection-icons',
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    this.URL_ROUTE = INSPECTIONS;
    if (props.match.url?.includes('arff/inspections')) {
      this.URL_ROUTE = '/arff/inspections/';
    }
    if (props.match.url?.includes('sms/inspections')) {
      this.URL_ROUTE = '/sms/inspections/';
    }
  }

  async componentDidMount() {
    const {
      actionFetch,
      match,
      shiftTypes,
      actionFetchShiftTypes
    } = this.props;
    const id = get(match, 'params.id') || this.props.id;
    await actionFetch(id, match?.url?.includes('/hangar/'));
    this.setState({ loadingStatus: true });
    if (!shiftTypes?.length) await actionFetchShiftTypes();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.user.id) {
      return {
        ...state,
        maintenance: {
          ...state.maintenance,
          completed_by: {
            id: props.user.id,
            fullname: props.user.fullname
          }
        },
        shiftSetting: props.user?.airport_settings?.inspection_shift
      };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const {
      activeInspectionField,
      loadingStatus,
      initialRender,
      inspectionReview
    } = this.state;
    const {
      answer,
      fetchInspectionAnswerAction,
      actionFetchChecklistAttachments,
      actionFetch,
      match
    } = this.props;
    if (answer.id && inspectionReview === undefined && initialRender === true) {
      this.setState({
        initialRender: false,
        inspectionReview: answer.review_completed
      });
    }
    if (
      answer.version
      && activeInspectionField === undefined
      && Object.keys(answer.version).length > 0
    ) {
      if (answer?.version?.form_id) {
        actionFetchChecklistAttachments(answer?.version?.form_id);
      }
      let flag = true;
      let activeIdx = 0;
      answer.version.schema.fields.forEach((field) => {
        if (field.type === 'inspection') {
          const checklist_length = Object.keys(
            field.checklist.filter(
              item => checkChecklistCondition(item, { 'shiftName': answer.shift_name, ...(answer.response || {}) })
            )
          ).length;
          if (answer.supplement_inspection && answer?.selected_checklist?.length > 0) {
            const selected_checklist = answer.selected_checklist.filter(category => category.id === field.id);
            if (selected_checklist.length > 0 && flag) {
              flag = false;
              activeIdx = field.id;
            }
          } else if (checklist_length > 0 && flag) {
            flag = false;
            activeIdx = field.id;
          }
        }
      });
      this.setState({ activeInspectionField: activeIdx });
    }
    if (
      answer.version
      && Object.keys(answer.version).length > 0
      && this.state.init === true
    ) {
      this.setState({ loadingStatus: true });
      let inspFields = this.props.answer.version.schema.fields.filter(
        f => f.type === 'inspection'
      );
      const columns = inspFields.length > 0 ? inspFields[0].columns : [];
      if (inspFields.length > 0) {
        inspFields = inspFields.reduce(
          (all, field) => ({ ...all, [field.id]: field }),
          {}
        );
      }
      let additionalFields = this.props.answer.version.schema.fields.filter(
        f => f.type !== 'inspection'
      );
      if (additionalFields.length > 0) {
        additionalFields = additionalFields.reduce(
          (all, field) => ({ ...all, [field.id]: field }),
          {}
        );
      }
      this.setState({
        init: false,
        additionalFields,
        inspFields,
        columns,
        loadingStatus: false
      });
    }
    const id = get(match, 'params.id') || this.props.id;
    if (
      prevProps?.fetchInspectionAnswerAction?.loading === true
      && fetchInspectionAnswerAction?.loading === false
      && loadingStatus
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      actionFetch(id, match?.url?.includes('/hangar/'));
      this.setState({ loadingStatus: false });
    }
  }

  componentWillUnmount() {
    const { actionClear } = this.props;
    actionClear();
  }

  handleDropDown = () => {
    this.setState(prevState => ({
      inspectionDropdown: !prevState.inspectionDropdown
    }));
  };

  // eslint-disable-next-line react/sort-comp
  changeSelectedField(fieldId) {
    this.setState({
      activeInspectionField: fieldId
    });
  }

  toggle(view) {
    this.setState({ view });
  }

  goToInspection(id, answerId) {
    const { history } = this.props;
    history.push(`${this.URL_ROUTE}${id}/${answerId}/edit-inspection`);
  }

  goToInspectionRoute(id) {
    const { history } = this.props;
    history.push(`${this.URL_ROUTE}${id}/inspection-route`);
  }

  showDelPopUp = () => {
    const { delPopup } = this.state;
    this.setState({
      delPopup: !delPopup
    });
  };

  handleDelete = () => {
    const { actionDeleteInspectionAnswer, history, answer } = this.props;
    const { delPopup } = this.state;
    actionDeleteInspectionAnswer(answer.id, { date: new Date() });
    this.setState({ delPopup: !delPopup });
    history.push(`${this.URL_ROUTE}`);
  };

  toggleStatus = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ isPressed: !this.state.isPressed });
  };

  ops_logs = historys => historys.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  handleInspectionReview = () => {
    const { actionInspectionReviewComplete, match } = this.props;
    const {
      reviewComment
    } = this.state;
    const id = get(match, 'params.id') || this.props.id;
    const data = {
      comment: reviewComment
    };
    this.setState({
      inspectionReview: true,
      reviewModal: false,
      reviewComment: undefined
    }, () => {
      actionInspectionReviewComplete(id, data);
    });
  };

  handleFlaggedInspection = () => {
    const { actionFlaggedInpection, match, id } = this.props;
    const { reInspectionDate } = this.state;
    const detailId = get(match, 'params.id') || id;
    actionFlaggedInpection(
      detailId,
      {
        date: moment(reInspectionDate).format('YYYY-MM-DDZ')
      }
    );
    this.setState({
      reInspectModal: false
    });
  };

  closeModal = () => {
    this.setState({ emailModal: false });
  }

  checkIsReviewdPerson = () => {
    const { answer, user } = this.props;
    let isEligible = false;
    if (answer?.settings?.review_users?.length > 0) {
      isEligible = answer?.settings?.review_users?.filter(userId => userId === user?.id)?.length > 0;
    }
    if (!isEligible && answer?.settings?.review_roles?.length > 0) {
      isEligible = answer?.settings?.review_roles?.filter(roleId => (
        user?.roles?.filter(role => role?.id === roleId)?.length > 0
      ))?.length > 0;
    }
    if (answer?.settings?.review_users?.length === 0 && answer?.settings?.review_roles?.length === 0) {
      isEligible = true;
    }
    if (answer?.settings?.review_unsatisfactory?.value === 'unsatisfactory' && answer?.issues === 0) {
      isEligible = false;
    }
    return isEligible;
  }

  render() {
    const {
      shiftTypes,
      answer,
      match,
      mergedView,
      answer: {
        open_workorders,
        version,
        response,
        remarks,
        shift_name,
        maintenance_workorders,
        airfield_workorders,
        ...inspection
      },
      checklistAttachments,
      linkedField,
      profile
    } = this.props;
    const id = get(match, 'params.id') || this.props.id;
    const {
      activeInspectionField,
      loadingStatus,
      inspFields,
      additionalFields,
      columns,
      shiftSetting
    } = this.state;

    if (mergedView && loadingStatus) {
      return <Loading loadingStatus={loadingStatus} />;
    }
    if (mergedView && !Object.keys(answer).length) {
      return null;
    }
    let selected_checklist = inspection?.selected_checklist;
    if (selected_checklist && Object.keys(selected_checklist).length > 0) {
      selected_checklist = selected_checklist.reduce(
        (all, field) => ({ ...all, [field.id]: field }),
        {}
      );
    }
    let titles = {
      history_header: { id: 'inspections.detail.history.header', default: 'Inspection #{id}' },
      audit_details: { id: 'inspections.details.title', default: 'Inspections Details' }
    };
    if (this.URL_ROUTE?.includes('sms')) {
      titles = {
        history_header: { id: 'safetyAudit.detail.history.header', default: 'Audit #{id}' },
        audit_details: { id: 'safetyAudits.complete_audit.details', default: 'Audit Details' }
       };
    }
    return (
      <>
        {loadingStatus && <Loading loadingStatus={loadingStatus} />}
        <SectionHeader
          icon={
            inspection?.icon?.includes('.png')
              ? this.images[inspection.icon]?.default
              : this.images[`${inspection.icon}.svg`]?.default
          }
          translationID="invalid"
          defaultTitle={answer.inspection}
        />
        <HeaderBack
            translationID="inspection.start.back"
            translationDefault="Back"
            backRoute={this.URL_ROUTE}
            exactRoute={this.URL_ROUTE}
        />

        <div className={styles.container}>
          { Object.keys(answer).length > 0 && (
            <DataSummary
              answer={answer}
              inspection={inspection}
              shiftTypes={shiftTypes}
              shiftSetting={shiftSetting}
              url={this.URL_ROUTE}
            />
           )}
          <div className={styles.additional}>
            {Object.keys(answer).length > 0 && (
              <AdditionalInformation
                answer={answer}
                fields={additionalFields}
                active
                mergedView={mergedView}
                linkedField={linkedField}
                user={profile}
              />
            )}
          </div>
          <div className={styles.viewSelector}>
               <FormattedMessage
                  tagName="h4"
                  id={titles.audit_details.id}
                  defaultMessage={titles.audit_details.default}
                />
          </div>

          <div className={styles.view}>
            {Object.keys(answer).length > 0 && (
              <Selector
                form={version.schema}
                answers={response}
                shift={shift_name}
                activeInspectionField={activeInspectionField}
                changeSelectedField={this.changeSelectedField}
                columnDetails={columns}
                supplementInspection={inspection?.supplement_inspection}
                selected_checklist={inspection?.selected_checklist}
                url={this.URL_ROUTE}
              />
            )}
            <FieldDetail
              toleranceInspection={inspection?.tolerance_inspection}
              toleranceResult={inspection?.tolerance_result}
              fields={inspection?.supplement_inspection
                && selected_checklist && Object.keys(selected_checklist)?.length > 0 ? selected_checklist : inspFields}
              remarks={remarks}
              selected={activeInspectionField}
              answers={response}
              shift={shift_name}
              answerId={id}
              columnDetails={columns}
              InspStartDate={answer.start_date}
              InspCreatedDate={answer.created_date}
              inspectionid={version}
              shiftTypes={shiftTypes}
              mergedView={mergedView}
              notams={answer?.notams}
              checklistAttachments={checklistAttachments}
              connected_actions={answer?.connected_actions}
              answerDetails={answer}
              url={this.URL_ROUTE}
            />
          </div>
        </div>
      </>
    );
  }
}

SubmissionDetail.propTypes = {
  actionFetch: PropTypes.func.isRequired,
  actionClear: PropTypes.func.isRequired,
  match: PropTypes.shape({}).isRequired,
  answer: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/require-default-props
  shiftTypes: PropTypes.arrayOf(PropTypes.shape({}))
};

const mapStateToProps = (state, props) => ({
  answer:
    get(
      state,
      `inspection.answer[${get(props, 'match.params.id') || props.id}]`
    ) || {},
  shiftTypes: state.inspection.shiftTypes,
  profile: state.auth.profile,
  inspection: state.inspection.inspection,
  user: state.auth.profile,
  checklistAttachments: state.inspection.checklistAttachments,
  fetchInspectionAnswerAction: state.inspection.fetchInspectionAnswerAction
});

const mapDispatchToProps = dispatch => ({
  actionFetch: (id, fromHangar) => {
    dispatch(fetchInspectionAnswer(id, fromHangar));
  },
  actionClear: () => {
    dispatch(clearInspectionAnswer());
  },
  actionFetchChecklistAttachments: (id) => {
    dispatch(getChecklistAttachments(id));
  },
  actionFetchShiftTypes: () => {
    dispatch(fetchShiftTypes());
  }

});

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionDetail);
